export const generatedStoryPreviewModalMessages = {
  dialogTitle: 'Preview Generated Story: {title}',
  dialogDescription:
    'Preview the generated story "{title}" with {spreadCount} spreads',
} as const;
